export function formatRestaurantPayrollDecimal(value: number, fractionDigits: number): string {
  return value.toFixed(fractionDigits).replace('.', ',');
}

export function formatRestaurantPayrollNumber(value: number): string {
  return String(value).replace('.', ',');
}

export function formatRestaurantPayrollDate(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  return match ? `${match[3]}.${match[2]}.${match[1]}` : value;
}
